/**
 * Service de integración SII (factoring).
 * Thin wrappers sobre API.factoring.*.
 */

import API from "@/api";

export const estaVinculado = (empresaId: number | string) =>
	(API as any).factoring.sii_vinculado(empresaId);

/**
 * Vincula la empresa al SII guardando la clave (firma equivalente al original
 * `API.factoring.sii(empresaId, password, c_password)`).
 */
export const guardarPassword = (empresaId: number | string, password: string, cPassword: string) =>
	(API as any).factoring.sii(empresaId, password, cPassword);

export const subirCertificado = (empresaId: number | string, pfx: File | Blob | Array<File | Blob>, password: string) =>
	(API as any).factoring.certificado_sii(empresaId, pfx, password);
